import React from "react";
import {withFormsy} from 'formsy-react';

const InputWrapper = (props) => {

    const errorMessage = (props.showError() || props.isFormSubmitted()) && props.getErrorMessage();
    let className = props.showRequired() ? 'required ' : '';

    className += (!props.isValid() && props.isFormSubmitted()) ? ' text-danger is-invalid ' : '';

    let value = props.getValue();
    if (props.formatAsDate && value && TB.moment(value).isValid()) {
        value = TB.moment(props.getValue())
    }
    return (
        <div className={"transition-all ease-in flex flex-col form-group " + className + " " + props.className}>
            {props.label && (
                <label className={`col-form-label ${props.labelClassName || ''}`}>
                    {props.label}
                    {props.required && <span className="required-symbol"> *</span>}
                </label>
            )}

            {props.children && React.Children.map(props.children, child => (
                React.cloneElement(props.children, {
                    disabled: props.disabled,
                    value: value,
                    onChange: (e) => {

                        if (e instanceof TB.moment){
                            props.setValue(e.toISOString())
                        }else if (e?.target?.type === "checkbox"){
                            props.setValue(e.target.checked ? 1 : 0)
                        } else if (e?.target?.value !== undefined) {
                            props.setValue(e.target.value)
                        } else props.setValue(e)
                    },
                    name: props.name,
                    placeholder: props.placeholder,
                    tabIndex: props.isReadOnly ? -1 : undefined,
                    required: props.isRequired(),
                    status: !!errorMessage ? 'error' : undefined,
                    ...child.props
                })
            ))}

            <div className="invalid-feedback block transition-all ease-in"
                 style={errorMessage ? {opacity: 1,height: 20, ...(props.invalidStyles || {})}:{opacity: 0,height: 0}}>
                {errorMessage}
            </div>

        </div>
    )
}

export default withFormsy(InputWrapper)